// extracted by mini-css-extract-plugin
module.exports = {"modalCamp":"ModalCampaign_modalCamp__xVGrB","countDown":"ModalCampaign_countDown__3S-9h"};